// Generated from tools/agent_event_catalog/catalog.json by generate.mjs.
// Do not edit directly.

import { artifactUpdatedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/artifact_updated';
import { assistantImageDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/assistant_image';
import { assistantReasoningDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/assistant_reasoning';
import { assistantTextDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/assistant_text';
import { automationRunRequestedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/automation_run_requested';
import { childCompletedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/child_completed';
import { domainEventObservedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/domain_event_observed';
import { fileRefDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/file_ref';
import { interruptRequestedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/interrupt_requested';
import { itemCompactionDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/item_compaction';
import { itemOtherDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/item_other';
import { observedOutreachUpdatedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/observed_outreach_updated';
import { outreachKickoffDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/outreach_kickoff';
import { outreachMonitorWakeUpDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/outreach_monitor_wake_up';
import { outreachRunnerKickoffDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/outreach_runner_kickoff';
import { pageContextInitDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/page_context_init';
import { pokeDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/poke';
import { retryToolCallDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/retry_tool_call';
import { runCancelRequestedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/run_cancel_requested';
import { runCancelledDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/run_cancelled';
import { runCompletedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/run_completed';
import { runFailedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/run_failed';
import { runInterruptedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/run_interrupted';
import { runProviderRetryingDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/run_provider_retrying';
import { runStartedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/run_started';
import { slackThreadMessageDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/slack_thread_message';
import { staffImessageApprovalDecisionDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/staff_imessage_approval_decision';
import { staffImessageNotificationSentDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/staff_imessage_notification_sent';
import { staffImessageReactionDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/staff_imessage_reaction';
import { statusUpdateDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/status_update';
import { stopRequestedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/stop_requested';
import { subagentInitDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/subagent_init';
import { threadSummaryDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/thread_summary';
import { toolApprovalDeniedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/tool_approval_denied';
import { toolApprovalGrantedDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/tool_approval_granted';
import { toolApprovalRequiredDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/tool_approval_required';
import { toolCallDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/tool_call';
import { toolOutputDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/tool_output';
import { userImageDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/user_image';
import { userMessageDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/user_message';
import { userQuestionAnsweredDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/user_question_answered';
import { userQuestionCancelledDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/user_question_cancelled';
import { userQuestionRequiredDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/user_question_required';
import { watchDefinitions } from '@apps/web/features/phoebe_chat_v3/registry/definitions/watch';

export const generatedDefinitionModules = [
    artifactUpdatedDefinitions,
    assistantImageDefinitions,
    assistantReasoningDefinitions,
    assistantTextDefinitions,
    automationRunRequestedDefinitions,
    childCompletedDefinitions,
    domainEventObservedDefinitions,
    fileRefDefinitions,
    interruptRequestedDefinitions,
    itemCompactionDefinitions,
    itemOtherDefinitions,
    observedOutreachUpdatedDefinitions,
    outreachKickoffDefinitions,
    outreachMonitorWakeUpDefinitions,
    outreachRunnerKickoffDefinitions,
    pageContextInitDefinitions,
    pokeDefinitions,
    retryToolCallDefinitions,
    runCancelRequestedDefinitions,
    runCancelledDefinitions,
    runCompletedDefinitions,
    runFailedDefinitions,
    runInterruptedDefinitions,
    runProviderRetryingDefinitions,
    runStartedDefinitions,
    slackThreadMessageDefinitions,
    staffImessageApprovalDecisionDefinitions,
    staffImessageNotificationSentDefinitions,
    staffImessageReactionDefinitions,
    statusUpdateDefinitions,
    stopRequestedDefinitions,
    subagentInitDefinitions,
    threadSummaryDefinitions,
    toolApprovalDeniedDefinitions,
    toolApprovalGrantedDefinitions,
    toolApprovalRequiredDefinitions,
    toolCallDefinitions,
    toolOutputDefinitions,
    userImageDefinitions,
    userMessageDefinitions,
    userQuestionAnsweredDefinitions,
    userQuestionCancelledDefinitions,
    userQuestionRequiredDefinitions,
    watchDefinitions,
] as const;
